import React from 'react'

const OverlayMenu = ({ toggleMenuOpen, awsPrefix }) => {
	return(
		<div className={`MenuContainer`}>
			<div className={`FlexContainer Row FullWidth Fixed Top Height075`}>
				<div className={`FlexContainer Flex Row AlignCentre FlexStart`}></div>
				<div className={`FlexContainer Flex250 Row AlignCentre SpaceBetween SpaceLeftX4 SpaceRightX4 HideMobile`}></div>
				<div className={`FlexContainer Flex Row AlignCentre JustifyCentre Clickable SuperTop`} onClick={() => toggleMenuOpen(false)}>
					<img className={`MenuBurger SpaceLeftX8`} src={`${awsPrefix}icons/close.svg`} alt="menu close"/>
				</div>
			</div>
			<a href="#home" onClick={() => toggleMenuOpen(false)} className={`aOne White BoldText TextCentre Clickable`}>Home</a>
			<a href="#about" onClick={() => toggleMenuOpen(false)} className={`aOne White BoldText TextCentre Clickable SpaceAbove`}>What We Do</a>
			<a href="#technology" onClick={() => toggleMenuOpen(false)} className={`aOne BoldText White TextCentre Clickable SpaceAbove`}>Technology</a>
			<a href="#team" onClick={() => toggleMenuOpen(false)} className={`aOne White BoldText TextCentre Clickable SpaceAbove`}>Team</a>
			<a href="#contact" onClick={() => toggleMenuOpen(false)} className={`aOne White BoldText TextCentre Clickable SpaceAbove`}>Contact</a>
		</div>
	)
}

export default OverlayMenu